import { render, staticRenderFns } from "./CloudSelection.vue?vue&type=template&id=8e9a2fec&scoped=true&"
import script from "./CloudSelection.vue?vue&type=script&lang=ts&"
export * from "./CloudSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CloudSelection.vue?vue&type=style&index=0&id=8e9a2fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9a2fec",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QImg});
